<template>
  <div>
    <div class="box-preview-header clearfix">
      <div class="tab">
        <div class="tab-item active">
          {{ $t('general.labels.editing') }} {{ $t('general.labels.step') }}
        </div>
        <div class="tab-item" style="text-align: left; text-transform: none">
          <step-select></step-select>
        </div>
      </div>
      <device-buttons></device-buttons>
    </div>
    <div class="box-container" :class="'box-' + boxFormat + ' box-device-' + canvasPreviewDevice">
      <div class="box-preview-url-container">
        <input type="text" value="http://klickpages.com.br" disabled class="box-preview-url-field">
      </div>
      <div class="box-preview-content">
        <div :class="'kbx-modal is-open kbx-modal-type__' + boxFormat">
          <a href="#" class="kbx-modal-close"></a>
          <div class="kbx-container"
            :style="stepStyle('general')">
            <step></step>
            <highlight></highlight>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Step from './step/Main';
import StepSelect from './StepSelect';
import Highlight from './Highlight';
import DeviceButtons from './devicebuttons/Main';

export default {
  components: {
    Step,
    Highlight,
    StepSelect,
    DeviceButtons,
  },
  computed: mapGetters({
    boxFormat: 'boxFormat',
    stepStyle: 'stepStyle',
    canvasPreviewDevice: 'canvasPreviewDevice',
  }),
  methods: mapActions([
    'stepSetPreview',
  ]),
  mounted() {
    this.stepSetPreview(null);
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?567e1630
 **/